export const API_BASE_URL = "https://backendshineinlavender.quindl.com";

// export const API_BASE_URL = "https://ecom-api-quindl.onrender.com";

// export const API_BASE_URL = "http://localhost:5000";
